import React, { useState } from 'react';
import { Smile, Search, Copy, Smartphone, Monitor, Globe } from 'lucide-react';
import { toast } from 'react-hot-toast';

const EMOJI_CATEGORIES = {
  'Faces': [
    { emoji: '😀', name: 'Sorriso', android: '😀', ios: '😀', windows: '😀' },
    { emoji: '😂', name: 'Risos', android: '😂', ios: '😂', windows: '😂' },
    { emoji: '😍', name: 'Apaixonado', android: '😍', ios: '😍', windows: '😍' },
    { emoji: '😎', name: 'Óculos', android: '😎', ios: '😎', windows: '😎' },
    { emoji: '😭', name: 'Chorando', android: '😭', ios: '😭', windows: '😭' },
    { emoji: '😡', name: 'Bravo', android: '😡', ios: '😡', windows: '😡' },
    { emoji: '🤔', name: 'Pensando', android: '🤔', ios: '🤔', windows: '🤔' },
    { emoji: '😴', name: 'Dormindo', android: '😴', ios: '😴', windows: '😴' },
    { emoji: '😱', name: 'Assustado', android: '😱', ios: '😱', windows: '😱' },
    { emoji: '🤩', name: 'Estrela', android: '🤩', ios: '🤩', windows: '🤩' },
    { emoji: '😇', name: 'Anjo', android: '😇', ios: '😇', windows: '😇' },
    { emoji: '😜', name: 'Piscadinha', android: '😜', ios: '😜', windows: '😜' }
  ],
  'Gestos': [
    { emoji: '👍', name: 'Joinha', android: '👍', ios: '👍', windows: '👍' },
    { emoji: '👎', name: 'Polegar Baixo', android: '👎', ios: '👎', windows: '👎' },
    { emoji: '🙏', name: 'Oração', android: '🙏', ios: '🙏', windows: '🙏' },
    { emoji: '👋', name: 'Tchau', android: '👋', ios: '👋', windows: '👋' },
    { emoji: '✌️', name: 'Paz', android: '✌️', ios: '✌️', windows: '✌️' },
    { emoji: '🤝', name: 'Aperto de Mão', android: '🤝', ios: '🤝', windows: '🤝' },
    { emoji: '👏', name: 'Palmas', android: '👏', ios: '👏', windows: '👏' },
    { emoji: '💪', name: 'Força', android: '💪', ios: '💪', windows: '💪' }
  ],
  'Objetos': [
    { emoji: '💡', name: 'Ideia', android: '💡', ios: '💡', windows: '💡' },
    { emoji: '🔑', name: 'Chave', android: '🔑', ios: '🔑', windows: '🔑' },
    { emoji: '📱', name: 'Celular', android: '📱', ios: '📱', windows: '📱' },
    { emoji: '💻', name: 'Notebook', android: '💻', ios: '💻', windows: '💻' },
    { emoji: '🎮', name: 'Videogame', android: '🎮', ios: '��', windows: '🎮' },
    { emoji: '📷', name: 'Câmera', android: '📷', ios: '📷', windows: '📷' },
    { emoji: '🎧', name: 'Fones', android: '🎧', ios: '🎧', windows: '🎧' },
    { emoji: '☕', name: 'Café', android: '☕', ios: '☕', windows: '☕' }
  ],
  'Natureza': [
    { emoji: '🌺', name: 'Flor', android: '🌺', ios: '🌺', windows: '🌺' },
    { emoji: '🌲', name: 'Árvore', android: '🌲', ios: '🌲', windows: '🌲' },
    { emoji: '🌈', name: 'Arco-íris', android: '🌈', ios: '🌈', windows: '🌈' },
    { emoji: '⭐', name: 'Estrela', android: '⭐', ios: '⭐', windows: '⭐' },
    { emoji: '🌙', name: 'Lua', android: '🌙', ios: '🌙', windows: '🌙' },
    { emoji: '☀️', name: 'Sol', android: '☀️', ios: '☀️', windows: '☀️' },
    { emoji: '🌊', name: 'Onda', android: '🌊', ios: '🌊', windows: '🌊' },
    { emoji: '🍀', name: 'Trevo', android: '🍀', ios: '🍀', windows: '🍀' }
  ],
  'Comida': [
    { emoji: '🍕', name: 'Pizza', android: '🍕', ios: '🍕', windows: '🍕' },
    { emoji: '🍔', name: 'Hambúrguer', android: '🍔', ios: '🍔', windows: '🍔' },
    { emoji: '🍦', name: 'Sorvete', android: '🍦', ios: '🍦', windows: '🍦' },
    { emoji: '🍺', name: 'Cerveja', android: '🍺', ios: '🍺', windows: '🍺' },
    { emoji: '🍷', name: 'Vinho', android: '🍷', ios: '🍷', windows: '🍷' },
    { emoji: '🍫', name: 'Chocolate', android: '🍫', ios: '🍫', windows: '🍫' },
    { emoji: '🍎', name: 'Maçã', android: '🍎', ios: '🍎', windows: '🍎' },
    { emoji: '🍌', name: 'Banana', android: '🍌', ios: '🍌', windows: '🍌' }
  ],
  'Símbolos': [
    { emoji: '❤️', name: 'Coração', android: '❤️', ios: '❤️', windows: '❤️' },
    { emoji: '🔥', name: 'Fogo', android: '🔥', ios: '🔥', windows: '🔥' },
    { emoji: '💎', name: 'Diamante', android: '💎', ios: '💎', windows: '💎' },
    { emoji: '✨', name: 'Brilho', android: '✨', ios: '✨', windows: '✨' },
    { emoji: '🎉', name: 'Festa', android: '🎉', ios: '🎉', windows: '🎉' },
    { emoji: '🚀', name: 'Foguete', android: '🚀', ios: '🚀', windows: '🚀' },
    { emoji: '⚡', name: 'Raio', android: '⚡', ios: '⚡', windows: '⚡' },
    { emoji: '💯', name: '100', android: '💯', ios: '💯', windows: '💯' }
  ]
};

const EmojiPicker = () => {
  const [search, setSearch] = useState('');
  const [selectedStyle, setSelectedStyle] = useState('default');
  const [selectedCategory, setSelectedCategory] = useState('Faces');
  const [copied, setCopied] = useState(null);

  const styles = [
    { id: 'default', name: 'Padrão', icon: Smile },
    { id: 'android', name: 'Android', icon: Smartphone },
    { id: 'ios', name: 'iOS', icon: Smartphone },
    { id: 'windows', name: 'Windows', icon: Monitor }
  ];

  const getEmojiByStyle = (emojiObj) => {
    switch (selectedStyle) {
      case 'android': return emojiObj.android;
      case 'ios': return emojiObj.ios;
      case 'windows': return emojiObj.windows;
      default: return emojiObj.emoji;
    }
  };

  const allEmojis = Object.values(EMOJI_CATEGORIES).flat();
  const filtered = allEmojis.filter(e =>
    e.name.toLowerCase().includes(search.toLowerCase()) ||
    e.emoji.includes(search)
  );

  const copyEmoji = (emoji) => {
    navigator.clipboard.writeText(emoji);
    setCopied(emoji);
    toast.success('Emoji copiado!');
    setTimeout(() => setCopied(null), 1200);
  };

  const displayEmojis = search ? filtered : EMOJI_CATEGORIES[selectedCategory];

  return (
    <div className="max-w-4xl mx-auto bg-white rounded-lg shadow p-6 mt-6">
      <div className="flex items-center gap-2 mb-6">
        <Smile className="w-6 h-6 text-gray-700" />
        <h1 className="text-2xl font-bold text-gray-900">Seletor de Emojis</h1>
      </div>
      
      <p className="text-gray-700 mb-6">Escolha o estilo de emoji e navegue por categorias. Clique em um emoji para copiar.</p>

      {/* Controles */}
      <div className="mb-6 space-y-4">
        {/* Busca */}
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
          <input
            type="text"
            value={search}
            onChange={e => setSearch(e.target.value)}
            placeholder="Buscar por nome ou emoji..."
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>

        {/* Estilos */}
        <div className="flex flex-wrap gap-2">
          {styles.map(style => (
            <button
              key={style.id}
              onClick={() => setSelectedStyle(style.id)}
              className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                selectedStyle === style.id
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              <style.icon className="w-4 h-4" />
              {style.name}
            </button>
          ))}
        </div>

        {/* Categorias (apenas quando não há busca) */}
        {!search && (
          <div className="flex flex-wrap gap-2">
            {Object.keys(EMOJI_CATEGORIES).map(category => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-3 py-1 rounded-full text-sm font-medium transition-colors ${
                  selectedCategory === category
                    ? 'bg-blue-600 text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Grid de Emojis */}
      <div className="grid grid-cols-6 sm:grid-cols-8 md:grid-cols-10 lg:grid-cols-12 gap-3">
        {displayEmojis.length === 0 && (
          <div className="col-span-full text-center py-8 text-gray-500">
            Nenhum emoji encontrado.
          </div>
        )}
        {displayEmojis.map((emojiObj, index) => {
          const emoji = getEmojiByStyle(emojiObj);
          return (
            <button
              key={`${emojiObj.emoji}-${index}`}
              onClick={() => copyEmoji(emoji)}
              className={`flex flex-col items-center p-3 rounded-lg border transition-all duration-200 hover:scale-105 ${
                copied === emoji 
                  ? 'border-green-500 bg-green-50 shadow-lg' 
                  : 'border-gray-200 hover:border-blue-300 hover:bg-blue-50'
              }`}
              title={emojiObj.name}
            >
              <span className="text-2xl mb-1">{emoji}</span>
              <span className="text-xs text-gray-600 truncate w-full text-center leading-tight">
                {emojiObj.name}
              </span>
              {copied === emoji && (
                <span className="text-green-600 text-xs mt-1 font-medium">
                  Copiado!
                </span>
              )}
            </button>
          );
        })}
      </div>

      {/* Estatísticas */}
      <div className="mt-8 pt-6 border-t border-gray-200">
        <div className="flex justify-between items-center text-sm text-gray-500">
          <span>Total: {allEmojis.length} emojis</span>
          <span>Estilo: {styles.find(s => s.id === selectedStyle)?.name}</span>
        </div>
      </div>
    </div>
  );
};

export default EmojiPicker; 